import { createUseStyles } from 'react-jss';

const useNotFoundStyles = createUseStyles({
  page: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  }
});

export default useNotFoundStyles;
